import React, { useState, useEffect } from 'react';
import * as XLSX from 'xlsx';
import moment from 'moment';
import Grid from '@mui/material/Grid';
import Card from '@mui/material/Card';
import Stack from '@mui/material/Stack';
import Icon from '@mui/material/Icon';

import MDButton from 'components/MDButton';
import MDBox from 'components/MDBox';
import MDTypography from 'components/MDTypography';
import DashboardLayout from 'examples/LayoutContainers/DashboardLayout';
import DashboardNavbar from 'examples/Navbars/DashboardNavbar';
import Footer from 'examples/Footer';
import DataTable from 'examples/Tables/DataTable';
import { useLoading } from 'context/loading.context';
import { useMaterialUIController } from 'context';
import { getBranches } from 'network/service';


import BranchTable from './data';
import AddEditBranch from './components/addEditBranches';
import { getUsers } from 'network/service';
import AddUserDetails from './components/addUserPopup';
export default function Branches() {

    const { showLoader, hideLoader } = useLoading();
    const [controller, dispatch] = useMaterialUIController();
    const [branchPopup, setBranchPopup] = useState({ open: false, details: null });
    const [userPopup, setUserPopup] = useState({ open: false, details: null });
    const { sidenavColor } = controller;
    const [branches, setBranches] = useState([]);
    const [users, setUsers] = useState([]);


    const { formBranchRows, branchHeaders, formUserRows, userHeaders } = BranchTable();


    const fetchBranches = () => {
        showLoader();
        getBranches()
            .then((resp) => {
                hideLoader();
                setBranches(resp.data);
            })
            .catch((err) => {
                hideLoader();
                console.log(err);
            });
    };

    const fetchUsers = () => {
        getUsers().then((resp) => {
            setUsers(resp.data);
        }).catch((err) => {
            console.log(err);
        })
    }

    useEffect(() => {
        fetchBranches();
    }, []);

    useEffect(() => {
        fetchUsers();
    }, []);

    const exportToExcel = (data, filename) => {
        try {
            const wb = XLSX.utils.book_new();
            const ws = XLSX.utils.json_to_sheet(data);
            XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
            XLSX.writeFile(wb, `${filename}.xlsx`);
        } catch (error) {
            console.error('Error exporting to Excel:', error);
        }
    };

    const editBranch = (details) => {
        setBranchPopup({ open: true, details: details });
    }



    return (


        <DashboardLayout>
            <DashboardNavbar />
            <MDBox pt={6} pb={3}>
                {branchPopup.open && <AddEditBranch isopen={branchPopup.open} details={branchPopup.details} handleclose={() => { setBranchPopup({ open: false, details: null }) }} handlesuccess={() => { fetchBranches(); setBranchPopup({ open: false, details: null }) }} />}
                {userPopup.open && <AddUserDetails isopen={userPopup.open} details={userPopup.details} handleclose={() => { setUserPopup({ open: false, details: null }) }} handlesuccess={() => { fetchUsers(); setUserPopup({ open: false, details: null }) }} />}
                <Grid container spacing={6}>
                    <Grid item xl={6} md={12} xs={12}>
                        <Card sx={{ height: "100%" }}>
                            <MDBox
                                mx={2}
                                mt={-3}
                                py={3}
                                px={2}
                                variant="gradient"
                                bgColor={sidenavColor}
                                borderRadius="lg"
                                coloredShadow="info"
                            >
                                <MDTypography variant="h6" color="white">
                                    Branches
                                </MDTypography>
                            </MDBox>
                            <Stack
                                direction="row-reverse"
                                justifyContent="flex-start"
                                alignItems="center"
                                spacing={2}
                            >
                                <MDBox pt={3} pr={3}>
                                    <MDButton
                                        variant="outlined"
                                        color="success"
                                        onClick={() => {
                                            setBranchPopup({ open: true, details: null });
                                        }}
                                    >
                                        Add Branch
                                    </MDButton>
                                </MDBox>
                            </Stack>
                            <MDBox sx={{ maxHeight: "100vh", overflow: 'auto' }}>
                                <DataTable
                                    entriesPerPage={{ defaultValue: 5, entries: [5, 10] }}
                                    table={{
                                        columns: branchHeaders,
                                        rows: formBranchRows(branches, editBranch)
                                    }}
                                    noEndBorder
                                    canSearch
                                />
                            </MDBox>
                        </Card>
                    </Grid>
                    <Grid item xl={6} md={12} xs={12}>
                        <Card sx={{ height: "100%" }}>
                            <MDBox
                                mx={2}
                                mt={-3}
                                py={3}
                                px={2}
                                variant="gradient"
                                bgColor={sidenavColor}
                                borderRadius="lg"
                                coloredShadow="info"
                            >
                                <MDTypography variant="h6" color="white">
                                    Users
                                </MDTypography>
                            </MDBox>
                            <Stack
                                direction="row-reverse"
                                justifyContent="flex-start"
                                alignItems="center"
                                spacing={2}
                            >
                                <MDBox pt={3} pr={3}>
                                    <MDButton
                                        variant="outlined"
                                        color="success"
                                        onClick={() => {
                                            setUserPopup({ open: true, details: null });
                                        }}
                                    >
                                        Add User
                                    </MDButton>
                                </MDBox>
                            </Stack>
                            <MDBox sx={{ maxHeight: "100vh", overflow: 'auto' }}>
                                <DataTable
                                    entriesPerPage={{ defaultValue: 5, entries: [5, 10] }}
                                    table={{
                                        columns: userHeaders,
                                        rows: formUserRows(users)
                                    }}
                                    noEndBorder
                                    canSearch
                                />
                            </MDBox>
                        </Card>
                    </Grid>
                </Grid>
            </MDBox>
            <Footer />
        </DashboardLayout>
    );
}
